import { ApolloClient } from '@apollo/client'

import {
  EmployeeSelectorV2ItemsDocument,
  EmployeesEmployeeNameLabelFragmentDoc,
} from 'generated/resources/graphql'

export const getEmployeeLabelById = async (
  value: unknown,
  apolloClient: ApolloClient<object>
): Promise<string> => {
  const id = String(value)

  try {
    const cacheId = apolloClient.cache.identify({
      __typename: 'EmployeesEmployeeName',
      id,
    })
    if (cacheId) {
      const cached = apolloClient.readFragment({
        fragment: EmployeesEmployeeNameLabelFragmentDoc,
        fragmentName: 'EmployeesEmployeeNameLabel',
        id: cacheId,
      })
      if (cached?.fullName) return cached.fullName
    }
  } catch {
    // fall through
  }

  try {
    const { data } = await apolloClient.query({
      query: EmployeeSelectorV2ItemsDocument,
      variables: { ids: [id] },
      fetchPolicy: 'cache-first',
    })
    const employee = data?.employees?.employeeNamesConnection?.nodes?.[0]
    if (employee?.fullName) return employee.fullName
  } catch {
    // fall through
  }

  return id
}
